import script from "./SessionData.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionData.vue?vue&type=script&setup=true&lang=js"

import "./SessionData.vue?vue&type=style&index=0&id=641c91d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-641c91d0"]])

export default __exports__